package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2025_04_26_Day_3() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The heroes start to spot cultivated rice fields. Korvis notices heavy smoke rising to the Northeast. Tuesday suspects arson. The heroes enter the village of Seshiss — a collection of homes on stilts, similar to Banshir. The leader of the village, Vroylani Boribosa approaches the heroes and explains how the Chuul emerged from Lake Drolida (a lake they fish and are certain doesn’t contain evil aberrations). The people fought them bravely, and the Chuul retreated, but the village has been decimated — burned homes, seven dead guards (⅓ of the militia), and nearly everyone wounded from the attack. Korvis explains that the heroes weren’t aware of the attack and were just passing through, but they want to help.")
    }
}
